export function getAddressCoordinatesFieldName(index: number) {
  return index === 0 ? 'route.source.address.coordinates' : (`route.destination_${index}.address.coordinates` as const)
}
